import { inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageComponent } from './component/message/message';
import { MessageListComponent } from './component/message-list/message-list';
import { DsButtonModule } from '@skyeng/libs/shared/ui-kit-v2/button';
import { DsInputModule } from '@skyeng/libs/shared/ui-kit-v2/input';
import { MessageRequestComponent } from './component/message-request/message-request';
import { SkyMiscModule } from '@skyeng/libs/shared/misc';
import { VimCoreUserModule } from '@skyeng/libs/vimbox-core/user';
import { TextEditorModule } from './component/text-editor/text-editor.module';
import { SkyI18nModule, registerTranslationsManuallyStatic } from '@skyeng/libs/shared/i18n';
import { DsNotificationModule } from '@skyeng/libs/shared/ui-kit-v2/notification';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { UploadedAttachmentCardComponent } from './component/uploaded-attachment-card/uploaded-attachment-card';
import { AttachmentPreviewComponent } from './component/attachment-preview/attachment-preview';
import { AttachmentFullsizeDialogComponent } from './component/attachment-fullsize-dialog/attachment-fullsize-dialog';
import { DsDialogModule } from '@skyeng/libs/shared/ui-kit-v2/dialog';
import { DsTooltipModule } from '@skyeng/libs/shared/ui-kit-v2/tooltip';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';
import { AutosizeModule } from 'ngx-autosize';
import entranslation from './translation/en.json';
import rutranslation from './translation/ru.json';

const declarations = [
  MessageComponent,
  MessageListComponent,
  MessageRequestComponent,
  UploadedAttachmentCardComponent,
  AttachmentPreviewComponent,
  AttachmentFullsizeDialogComponent,
];

@NgModule({
  declarations: [...declarations],
  imports: [
    CommonModule,
    DsButtonModule,
    DsInputModule,
    DsDialogModule,
    SkyMiscModule,
    VimCoreUserModule,
    TextEditorModule,
    SkyI18nModule,
    DsNotificationModule,
    TranslocoModule,
    DsTooltipModule,
    DsIconModule,
    AutosizeModule,
  ],
  exports: [...declarations],
})
export class SkyproMessagesModule {
  private translocoService = inject(TranslocoService);

  constructor() {
    registerTranslationsManuallyStatic('skyproLibMessages', this.translocoService, {
      en: entranslation,
      ru: rutranslation,
    });
  }
}
